import React, { Component } from 'react';

class Countdown extends Component {
  render() {
    return (
      <div className="Countdown">
        <p className="Big-number">3</p>      
     </div>
    );
  }
}

export default Countdown;



// WEBPACK FOOTER //
// ./src/Countdown.js